export class ReserveAppointmentNotFoundError extends Error {}
